import {
  ContactInfo, ContactInfoItem, IconWrapper, useStyles,
} from '@layouts/academy/academy.styles'
import RoomOutlined from '@material-ui/icons/RoomOutlined'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import LocalPhoneOutlinedIcon from '@material-ui/icons/LocalPhoneOutlined'
import MailOutline from '@material-ui/icons/MailOutline'
import React from 'react'
import PropTypes from 'prop-types'

const ContactInfoSection = ({
  email, phoneNumber, facility, style,
}) => {
  const classes = useStyles()

  const facilityAddress = (primaryFacility) => {
    const {
      name,
      zip,
      address1,
      formattedAddress,
    } = primaryFacility
    const mapSearchAddress = encodeURIComponent(`${name} ${zip} ${address1}`)
    return (
      <ContactInfoItem>
        <IconWrapper>
          <RoomOutlined className={classes.icon} titleAccess="address" />
        </IconWrapper>
        <Link href={`https://www.google.com/maps/?q=${mapSearchAddress}`} target="_blank" rel="noopener noreferrer">
          <Typography className={classes.contactLink} component="span">{formattedAddress}</Typography>
        </Link>
      </ContactInfoItem>
    )
  }

  return (
    <ContactInfo style={style}>
      {facility && facilityAddress(facility)}
      {phoneNumber && (
        <ContactInfoItem>
          <IconWrapper>
            <LocalPhoneOutlinedIcon className={classes.icon} titleAccess="phone" />
          </IconWrapper>
          <Link href={`tel:${phoneNumber}`}>
            <Typography className={classes.contactLink} component="span">{phoneNumber}</Typography>
          </Link>
        </ContactInfoItem>
      )}
      {email && (
        <ContactInfoItem>
          <IconWrapper>
            <MailOutline className={classes.icon} titleAccess="email" />
          </IconWrapper>
          <Link href={`mailto:${email}`}>
            <Typography className={classes.contactLink} component="span">{email}</Typography>
          </Link>
        </ContactInfoItem>
      )}
    </ContactInfo>
  )
}

export default ContactInfoSection

ContactInfoSection.propTypes = {
  facility: PropTypes.shape({
    name: PropTypes.string,
    address1: PropTypes.string,
    zip: PropTypes.string,
    formattedAddress: PropTypes.string,
  }),
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  style: PropTypes.object,
}
